/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actionTypes from './actionTypes';

const initilaState = {
  rebateProgramCode: {},
  createCms64Data: {
    rebateProgramCode: '',
    rebateProgramSelObj: {},
    planType: '',
    quarter: '',
    // userId: localStorage.getItem('logInUser'),
    rptQtr: '',
    codeDomainKey: 'STATE_CD',
    invoiceStartFlag: false,
    qtrFlag: false,
    cmsFlag: true,
  },
  errorMessages: [],
  gridData: [],
  paymentsData: {},
  responseCMSRpt: {},
  detailScreenObj: {},
  extraState: {
    fullScreenView: false,
    edit: false,
  },
};

const reducer = (state = initilaState, action) => {
  switch (action.type) {
    case actionTypes.GET_ALL_REBATE_PROGRAMS: {
      return { ...state, rebateProgramCode: action.payload };
    }
    case actionTypes.SET_CMS64_DATA: {
      return { ...state, createCms64Data: action.payload };
    }
    case actionTypes.SET_DETAIL_SCREEN: {
      return { ...state, detailScreenObj: action.payload };
    }
    case actionTypes.CREATE_CORRECT_CMS_GET_REPORT_QUARTER: {
      return { ...state, createCmsReport: action.payload };
    }
    case actionTypes.UPDATE_CORRECT_CMS_GET_REPORT_QUARTER: {
      return {
        ...state,
        createCmsReport: { ...state.createCmsReport, ...action.payload },
      };
    }
    case actionTypes.GET_PREVIOUS_QTR: {
      return { ...state, previousQtr: action.payload };
    }
    case actionTypes.GET_MAXQUARTER_FOR_CMS_REPORT: {
      var createCms64Data = state?.createCms64Data;
      if (createCms64Data) {
        createCms64Data.quarter = action.payload;
      } else {
        createCms64Data = {
          quarter: action.payload,
        };
      }
      return {
        ...state,
        createCms64Data: { ...createCms64Data },
        rptQtr: action.payload,
      };
    }
    case actionTypes.SET_CMS_REPORTING_GRPS: {
      return { ...state, cmsReportingGrps: action.cmsReportingGrps };
    }
    case actionTypes.REBATE_PRGBY_CMS: {
      return { ...state, rebatePrgByCMS: action.payload };
    }
    case actionTypes.SET_ERROR_MESSAGES: {
      return { ...state, errorMessages: action.payload };
    }
    case actionTypes.INVOICE_START_QTR:
      return { ...state, invStartQtr: action.invStartQtr };
    case actionTypes.SAVE_CMS_QTR_REPORT:
      return { ...state, saveCmsQtrRpt: action.payload };
    case actionTypes.CREATE_CMS_EXTRA_STATE:
      return { ...state, extraState: action.extraState };
    case actionTypes.CLEAR_CREATE_CMS_TAB:
      return { ...state };
    case actionTypes.RSCH_CMS_QTR_REPORT:
      return { ...state, gridData: action.payload };
    case actionTypes.PAYMENTS_DATA:
      return { ...state, paymentsData: action.payload };
    case actionTypes.CMS_API_RESPONE:
      return { ...state, responseCMSRpt: action.payload };
    default:
      return state;
  }
};

export default reducer;
